import { Box, Typography } from "@mui/material";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PuffLoader } from "react-spinners";
import { postData } from "../../services/Services";
import CustomModal from "../atomic/Modal/CustomModal";
import { css } from "@emotion/react";
import styles from "./AddResourcePage.module.css";
import { useSelector } from "react-redux";
import { AvatarIcon } from "../../assets";
import Button from "../atomic/Button/Button";

const AddResourcePage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const request_id = searchParams.get("request_id");
  const redirect_uri = searchParams.get("redirect_uri");
  const resource_id = searchParams.get("resource_id");
  const isRegister = searchParams.get("isRegister");
  const cancel_uri = searchParams.get("cancel");
  const twofa_type = searchParams.get("2fa_type");
  const authorization_code = searchParams.get("authorization_code");
  const client_id = searchParams.get("client_id");

  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [title, setTitle] = useState("");

  // Redux State
  const verifiedPhone = useSelector((state) => state.otpData.phone);
  const userData = useSelector((state) => state.userData.data);

  const handleAddResource = async (e) => {
    e.preventDefault();
    addResource();
  };

  const addResource = () => {
    // Add Resource Function
    setLoading(true);
    let addResourceData = {
      requestID: request_id,
      resourceID: resource_id,
    };
    postData("/v3/auth/login/pwa/add/resource", token, addResourceData)
      .then((res) => {
        if (res.data.status === 1) {
          setLoading(false);
          navigate(
            `/verify-otp?token=${token}&request_id=${request_id}&redirect_uri=${redirect_uri}&resource_id=${resource_id}&isRegister=${isRegister}&cancel=${cancel_uri}&authorization_code=${authorization_code}&2fa_type=${
              twofa_type ? twofa_type : ""
            }&client_id=${client_id}&isLastPage=true`
          );
        } else if (res.data.status === 300047) {
          setTitle("Gagal");
          setMessage(res.data.note);
          setOpen(true);
        } else {
          setTitle("Gagal");
          setMessage(res.data.note.nexsoft.payload.status.message);
          setOpen(true);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err) {
          setTitle("Gagal");
          setMessage("Add resource gagal");
          setOpen(true);
        }
      });
  };

  return (
    <div className={styles.loginContainer}>
      {loading && (
        <Box
          position={"absolute"}
          width="100vw"
          top="0"
          left="0"
          height="100vh"
          zIndex="9999999999"
          display="flex"
          alignItems="center"
          justifyContent={"center"}
        >
          <Box
            position={"absolute"}
            width="100vw"
            top="0"
            left="0"
            sx={{ background: "black", opacity: "10%" }}
            height="100vh"
            display="flex"
            alignItems="center"
            justifyContent={"center"}
          ></Box>
          <PuffLoader css={css} color={"black"} loading={loading} size={150} />
        </Box>
      )}
      <Box width="80%" sx={{ height: "100vh" }}>
        {!verifiedPhone && <div>Akses Tidak Diijinkan</div>}
        {verifiedPhone && (
          <Box height={"100%"}>
            <div
              style={{
                width: "100%",
                height: "100%",
                paddingBlock: "20px 0px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <div>
                <Box>
                  <img src={AvatarIcon} alt="user-grochat" />
                </Box>
                <br />
                <Typography
                  fontSize={20}
                  fontWeight={500}
                  sx={{ color: " #1D1D1D" }}
                >
                  {userData ? userData.name : ""}
                </Typography>
              </div>
              <br />
              <br />
              <br />
              <Typography fontWeight={400} fontSize={14} textAlign={"center"}>
                Grochat will have access to your profile
              </Typography>

              <Button
                value={`Lanjut sebagai ${
                  userData &&
                  (userData.name?.includes(" ")
                    ? userData.name?.substr(0, userData.name?.indexOf(" "))
                    : userData.name)
                }`}
                width={"100%"}
                height={"45px"}
                background={"#D81922"}
                color={"white"}
                onClick={handleAddResource}
              />
            </div>
          </Box>
        )}

        <CustomModal
          open={open}
          onClose={() => setOpen(false)}
          variant={"error"}
          text={message}
          title={title}
        />
      </Box>
    </div>
  );
};

export default AddResourcePage;
